import { Grid, Theme, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function PropertyServiceInfo(props: any) {
  const theme: Theme = useTheme();

  return (
    <Grid
      container
      sx={{
        width: '100%',
        maxWidth: '1280px',
        minWidth: '310px',
        margin: '0 auto',
      }}
    >
      <Grid item xs={12}>
        <Typography sx={theme.custom.styles.titleType2}>{props.headerContent}</Typography>
      </Grid>
      {props.infoContent}
    </Grid>
  );
}
